import { CancelValidationResponse } from "@dana/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface OpenOrdersDetailState  {
    isLoading: boolean,
    data: CancelValidationResponse | null,
    error: string | null,
}

const initialOpenOrderDetailState: OpenOrdersDetailState = {
    isLoading: false,
    data: null,
    error: null
};

// Create Immer reducer
const openOrdersDetailReducer = createTypedReducerWithImmer(initialOpenOrderDetailState, {
    // Start loading
    "OpenOrdersDetail/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "OpenOrdersDetail/PopulateResult": (draft, action: { data: any }) => {
        draft.data = action.data;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "OpenOrdersDetail/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "OpenOrdersDetail/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).openOrdersDetail = openOrdersDetailReducer;

// Define type for action usage
type OpenOrderDetailReducers = {
    openOrdersDetail: typeof openOrdersDetailReducer;
};

export type OpenOrdersDetailActions = Parameters<OpenOrderDetailReducers[keyof OpenOrderDetailReducers]>[1] | AnyAction;
